import { ajax } from '@setel/webcommon/exposes/ajax';
import { fetchPaginatedData, IPaginationParam } from 'lib/ajax-helper';
import { environments } from 'environments/environment';
import {
  IAdminOrder,
  IFuelOrdersFilter,
  IOrder,
} from 'shared/interfaces/orders.interface';

const BASE_URL = `${environments.apiOrderBaseUrl}/api/orders`;

export function getAdminOrder(orderId: string): Promise<IAdminOrder> {
  return ajax.get(`${BASE_URL}/orders/admin/orders/${orderId}`);
}

export function indexOrders(
  pagination: IPaginationParam,
  filters: IFuelOrdersFilter
) {
  return fetchPaginatedData<IOrder>(
    `${BASE_URL}/orders/admin/orders`,
    pagination,
    { params: filters }
  );
}
